import { Link as TanLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

export const Link = forwardRef<
  HTMLAnchorElement,
  {
    href: string | { pathname: string; search?: string; query?: any };
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    children?: React.ReactNode;
    style?: any;
    className?: string;
    title?: string;
    'aria-label'?: string;
    passHref?: boolean;
  }
>((props, ref) => {
  const { href, children, style, title, 'aria-label': ariaLabel } = props;
  let to = '';
  const search = {} as any;

  if (typeof href === 'string') {
    to = href;
  } else {
    to = href.pathname || '';
    if (href.search) {
      Object.assign(
        search,
        Object.fromEntries(new URLSearchParams(href.search)),
      );
    }
    if (href.query) {
      Object.assign(search, href.query);
    }
  }

  if (typeof window === 'undefined') {
    return children;
  }

  return (
    <TanLink
      to={to}
      search={search}
      style={style}
      ref={ref}
      className={props.className}
      title={title || (typeof children === 'string' ? children : undefined)}
      aria-label={
        ariaLabel ||
        title ||
        (typeof children === 'string' ? children : undefined)
      }
      onClick={props.onClick}
    >
      {children}
    </TanLink>
  );
});
